'use client';
import React, { useRef } from 'react';
import type { CATEGORIES } from '@/lib/mockArticles';

interface CategoryFilterBarProps {
  categories: typeof CATEGORIES;
  active: string;
  onChange: (slug: string) => void;
}

export default function CategoryFilterBar({
  categories,
  active,
  onChange,
}: CategoryFilterBarProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <div data-component-id="src/app/news-feed/components/CategoryFilterBar.tsx:19:4" data-component-path="src/app/news-feed/components/CategoryFilterBar.tsx" data-component-line="19" data-component-end-line="48" data-component-file="CategoryFilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-white%20rounded-2xl%20border%20border-slate-100%20shadow-card%20overflow-hidden%22%7D" className="bg-white rounded-2xl border border-slate-100 shadow-card overflow-hidden">
      <div data-component-id="src/app/news-feed/components/CategoryFilterBar.tsx:20:6" data-component-path="src/app/news-feed/components/CategoryFilterBar.tsx" data-component-line="20" data-component-end-line="47" data-component-file="CategoryFilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-1%20px-2%20py-2%20overflow-x-auto%20scrollbar-hide%22%7D"
        ref={scrollRef}
        className="flex items-center gap-1 px-2 py-2 overflow-x-auto scrollbar-hide"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {categories.map(cat => {
          const isActive = active === cat.slug;
          return (
            <button data-component-id="src/app/news-feed/components/CategoryFilterBar.tsx:28:12" data-component-path="src/app/news-feed/components/CategoryFilterBar.tsx" data-component-line="28" data-component-end-line="44" data-component-file="CategoryFilterBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
              key={`cat-${cat.slug}`}
              onClick={() => onChange(cat.slug)}
              className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap transition-all duration-150 shrink-0
                ${isActive
                  ? 'bg-primary-500 text-white shadow-sm'
                  : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
                }`}
            >
              {cat.label}
              <span data-component-id="src/app/news-feed/components/CategoryFilterBar.tsx:38:14" data-component-path="src/app/news-feed/components/CategoryFilterBar.tsx" data-component-line="38" data-component-end-line="43" data-component-file="CategoryFilterBar.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                className={`text-[11px] px-1.5 py-0.5 rounded-full font-semibold tabular-nums transition-colors duration-150
                  ${isActive ? 'bg-white/25 text-white' : 'bg-slate-100 text-slate-500'}`}
              >
                {cat.count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}